'use strict';

// Constructor
var Slides = function () {
//    this.name = 'slides';
//    console.log('%s module', this.name);

    if ($('main.home').length > 0) {
        window.onbeforeprint = function (event) {

            $("html, body").stop().animate({scrollTop: document.body.scrollHeight}, 10, 'swing', function () {

                $("html, body").stop().animate({scrollTop: (document.body.scrollHeight * -1)}, 10, 'swing', function () {
                    // Waypoint triggers the actions
                });
            });
        };
    }

//    var mediaQueryList = window.matchMedia('print');
//    mediaQueryList.addListener(function (mql) {
//        if (mql.matches) {
//            console.log('webkit equivalent of onbeforeprint');
////            window.scrollTo(0, document.body.scrollHeight);
//            $('.slide2 .right').addClass('active');
//
//
//        }
//    });



};

module.exports = Slides;
